import { render, staticRenderFns } from "./review-infinite-marquee.vue?vue&type=template&id=ab015892&scoped=true&"
import script from "./review-infinite-marquee.vue?vue&type=script&lang=js&"
export * from "./review-infinite-marquee.vue?vue&type=script&lang=js&"
import style0 from "./review-infinite-marquee.vue?vue&type=style&index=0&id=ab015892&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab015892",
  null
  
)

export default component.exports